package one.healthium.insights.domain.models

import one.healthium.domain.common.Insets

sealed interface ContentEntry {

    data class TitleEntry(
        val text: String
    ) : ContentEntry

    data class HeaderEntry(
        val text: String
    ) : ContentEntry

    data class ImageEntry(
        val url: String,
        val thumbUrl: String,
        val height: Int?,
    ) : ContentEntry

    data class TextEntry(
        val text: String,
    ) : ContentEntry

    data class RichTextEntry(
        val text: String,
        val insets: Insets?,
    ) : ContentEntry

    data class DayEntry(
        val title: String?,
        val meals: List<MealModel>
    ) : ContentEntry

    data class CardEntry(
        val title: String?,
        val imageUrl: String?,
        val hint: HintModel?,
        val action: ActionModel,
    ) : ContentEntry

    data class GroupEntry(
        val backgroundColor: ColorModel?,
        val insets: Insets?,
        val cornerRadius: Int?,
        val content: List<ContentEntry>,
    ) : ContentEntry

    data class Carousel(
        val content: List<CardModel>,
        val variant: String?,
    ) : ContentEntry

    data class ListItem(
        val title: String?,
        val emoji: String?,
        val backgroundColor: ColorModel?,
        val action: ActionModel,
    ) : ContentEntry

    data class ListItemPreview(
        val title: String?,
        val description: String?,
        val thumbUrl: String?,
        val action: ActionModel,
    ) : ContentEntry

    data class ImageCard(
        val title: String,
        val hint: HintModel?,
        val imageUrl: String,
        val action: ActionModel,
    ) : ContentEntry

    data class Tips(
        val config: TipsConfigModel?,
        val tips: List<TipModel>,
    ) : ContentEntry

    data class ShoppingList(
        val name: String,
        val color: ColorModel?,
        val action: ActionModel,
    ) : ContentEntry

    data class PlainText(
        val text: String,
        val style: TextStyleModel?,
        val insets: Insets?,
    ) : ContentEntry

    data class Line(
        val thickness: Int?,
        val color: ColorModel?,
        val indent: Int?,
        val endIndent: Int?,
    ) : ContentEntry

    data class Button(
        val text: String,
        val height: Int?,
        val containerColor: ColorModel?,
        val style: TextStyleModel?,
        val action: ActionModel,
        val insets: Insets?,
    ) : ContentEntry

    data class Row(
        val weights: List<Float>?,
        val content: List<ContentEntry>,
        val insets: Insets?,
        val action: ActionModel?,
    ) : ContentEntry

    data class Column(
        val content: List<ContentEntry>,
        val insets: Insets?,
        val action: ActionModel?,
    ) : ContentEntry

    data class Space(
        val size: Int,
    ) : ContentEntry

    data class Decorator(
        val content: ContentEntry,
        val backgroundColor: ColorModel?,
        val insets: Insets?,
        val margins: Insets?,
        val cornerRadius: Int?,
        val action: ActionModel?,
    ) : ContentEntry

    data class Anchor(
        val content: ContentEntry,
        val anchorId: String,
    ) : ContentEntry

    data class StickyContent(
        val content: ContentEntry,
    ) : ContentEntry

    data class HorizontalList(
        val content: List<ContentEntry>,
        val contentInsets: Insets?,
    ) : ContentEntry

    data class UnitSelectorContainer(
        val metric: List<ContentEntry>,
        val imperial: List<ContentEntry>,
    ) : ContentEntry
}